export default __webpack_public_path__ + "static/media/main_info_data_03.d7616cc4.png";